var map = {
	"./back.svg": 37911,
	"./calendar.svg": 90874,
	"./chart-box-outline-grey.svg": 79627,
	"./chart.svg": 47208,
	"./chevron-down.svg": 51728,
	"./chevron-up.svg": 87072,
	"./clock.svg": 5997,
	"./cog-outline.svg": 34393,
	"./cog-white.svg": 49202,
	"./copy.svg": 47918,
	"./cross-grey.svg": 74263,
	"./export.svg": 46707,
	"./external-link.svg": 86429,
	"./eye-closed-grey.svg": 29399,
	"./eye-opened-grey.svg": 76316,
	"./filter.svg": 63817,
	"./go-inside.svg": 8105,
	"./go-outside.svg": 32074,
	"./info.svg": 67292,
	"./password.svg": 5386,
	"./pencil-grey.svg": 64236,
	"./pencil-white.svg": 40671,
	"./people.svg": 37414,
	"./planet-favicon.png": 22252,
	"./play-button.svg": 91365,
	"./play-circle.svg": 48578,
	"./plus-circle.svg": 45304,
	"./refresh.svg": 39525,
	"./star-outline.svg": 48890,
	"./star.svg": 3740,
	"./stop-circle.svg": 90310,
	"./ticket.svg": 78609,
	"./trash.svg": 10967,
	"./user.svg": 51816,
	"./wallet.svg": 2033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;